import styled from 'styled-components';

export const ImageSlider = styled.div`
  width: 80vw;
  height: 200px;
  background-position: center;
  background-size: cover;
`;

export const DataSlider = styled.ul`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  height: 80px;
  justify-content: space-around;
  padding: 5px;
  position: relative;
  top: -80px;
`;

export const DataSliderList = styled.li`
  display: flex;
  font-size: 12px;
  margin-bottom: 5px;

  li {
    margin-right: 20px;
  }
`;

export const SliderHomeIcon = styled.img`
  color: white;
  height: 20px;
  margin-left: 5px;
`;